import { Base } from '@studiometa/js-toolkit';
import { Frame, Menu, Action, DataModel, DataEffect } from '@studiometa/ui';
import { nextTick } from '@studiometa/js-toolkit/utils';
import Accordion from '../Accordion/index.js';
import PriceRange from './PriceRange.js';
import Panel from '../Panel.js';

/**
 * Facets component
 */
export default class Facets extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Facets',
    refs: ['loadmore', 'container', 'products[]', 'counter'],
    components: {
      Frame,
      Action,
      Menu,
      Panel,
      PanelAccordion: Accordion,
      DataModel,
      DataEffect,
      PriceRange,
    },
  };

  /**
   * Get total products in listing
   * @returns {void}
   */
  get totalProducts() {
    return this.$refs.products.length;
  }

  /**
   * form
   * @returns {HTMLFormElement}
   */
  get form() {
    return this.$el.querySelector('form');
  }

  /**
   * Update the root component
   */
  onFrameFrameFetchAfter() {
    this.$root.$update();
  }

  /**
   * Click on loadmore
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onLoadmoreClick({ target }) {
    const url = target.dataset.href;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const results = html.querySelector(`[data-ref="Facets.container"]`);

        this.hideNewProducts(results);

        nextTick(() => {
          this.$refs.container.innerHTML += results.innerHTML;
        });

        const newLoadmore = html.querySelector(`[data-ref="Facets.loadmore"]`);
        if (newLoadmore) {
          this.$refs.loadmore.dataset.href = newLoadmore.dataset.href;
        } else {
          this.$refs.loadmore.style.display = 'none';
        }

        this.$update();

        nextTick(() => {
          setTimeout(() => {
            this.showNewProducts();
          }, 200);
          this.$refs.counter.innerHTML = this.totalProducts;
        });
      });
  }

  /**
   * [hideNewProducts description]
   * @param  {object} results element.
   * @returns {void}
   */
  hideNewProducts(results) {
    results.querySelectorAll('[data-ref="Facets.products[]"]').forEach((element) => {
      element.classList.add('tw-transition', 'tw-duration-300', 'tw-translate-y-4', 'tw-opacity-0');
    });
  }

  /**
   * Change class to new products to display them
   * @returns {void}
   */
  showNewProducts() {
    this.$refs.products.forEach((element) => {
      element.classList.remove('tw-translate-y-4', 'tw-opacity-0');
    });
  }
}
